// extracted by mini-css-extract-plugin
export default {"control":"Textarea-styles-module--control--JYaMa FormControls-module--form-control--TzGei form-control"};